var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import store from "@/store/";
let BreadcrumbsModule = class BreadcrumbsModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.storage = window.localStorage;
        this.breadcrumbs = {};
    }
    /**
     * Get breadcrumb object for current page
     * @returns object
     */
    get getBreadcrumbs() {
        return this.breadcrumbs;
    }
    /**
     * Get breadcrumb array for current page
     * @returns object
     */
    get pageBreadcrumbPath() {
        return this.breadcrumbs.pageBreadcrumbPath;
    }
    /**
     * Get current page title
     * @returns string
     */
    get pageTitle() {
        let breadCrumbsLocal = this.storage.getItem('breadCrumbs');
        if (breadCrumbsLocal) {
            let bcLocalObject = JSON.parse(breadCrumbsLocal);
            if (bcLocalObject && bcLocalObject.title && this.breadcrumbs != bcLocalObject)
                store.dispatch(Actions.SET_BREADCRUMB_ACTION, bcLocalObject);
        }
        return this.breadcrumbs.title;
    }
    [_a = Mutations.SET_BREADCRUMB_MUTATION](payload) {
        if (payload && Object.keys(payload).length > 0) {
            this.breadcrumbs = payload;
            this.storage.setItem('breadCrumbs', JSON.stringify(payload));
        }
    }
    [_b = Actions.SET_BREADCRUMB_ACTION](payload) {
        this.context.commit(Mutations.SET_BREADCRUMB_MUTATION, payload);
    }
    [_c = Actions.CLEAR_BREADCRUMB]() {
        this.context.commit(Mutations.SET_BREADCRUMB_MUTATION, {});
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BreadcrumbsModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BreadcrumbsModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BreadcrumbsModule.prototype, _c, null);
BreadcrumbsModule = __decorate([
    Module
], BreadcrumbsModule);
export default BreadcrumbsModule;
//# sourceMappingURL=BreadcrumbsModule.js.map